import { type CollectionSummaryJSONObject, isSystemTag } from '@ikegps/core-api';
import { action, observable, makeObservable } from 'mobx';
import { Services } from '../../services';
import { AppStore } from '../../store';

export class CollectionDuplicateModalCtrl {
	collections: CollectionSummaryJSONObject[];

	@observable duplicating: boolean = false;

	constructor(collections: CollectionSummaryJSONObject[]) {
		makeObservable(this);

		this.collections = collections;
	}

	//we take the departmentId as a parameter to make inter department duplication easier to implement even if it is not currently needed
	async duplicateCollections(departmentId: string) {
		if (this.duplicating) {
			return;
		}

		const collectionsByTag: { [tagId: string]: CollectionSummaryJSONObject[] } = {};
		for (const collection of this.collections) {
			const tagId = collection.tags.find((t) => !isSystemTag(t));
			if (collectionsByTag[tagId] != null) {
				collectionsByTag[tagId].push(collection);
			} else {
				collectionsByTag[tagId] = [collection];
			}
		}

		this.setDuplicating(true);
		for (const tagId of Object.keys(collectionsByTag)) {
			const collectionGroup = collectionsByTag[tagId];
			const tag = AppStore.Tag.get(tagId);
			if (departmentId == null) {
				await Services.Collection.duplicate(collectionGroup, tag.name);
			} else {
				await Services.Collection.duplicate(collectionGroup, tag.name, departmentId);
			}
		}
		this.setDuplicating(false);
	}

	@action private setDuplicating(duplicating: boolean) {
		this.duplicating = duplicating;
	}
}
